import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Routes, Route, Navigate, } from "react-router-dom";
// import { useEffect } from 'react';
import GoogleAnalytics from './components/analytics/GoogleAnalyticsConditional';
import Login from './components/login/Login';
import Home from "./components/home/Home";
// import HomeWithoutSplash from "./components/home/Home";
// import SidebarBottom from "./components/home/SidebarBottom";
// import Header from './components/header/Header';
import Footer from "./components/footer/Footer";
import RedeemHeader from "./components/redeem/RedeemHeader";
import RedeemBody from "./components/redeem/RedeemBody";
import SavedVideos from "./components/savedVideos/SavedVideos";
import Categories from "./components/savedVideos/Categories";
import Profile from "./components/profile/Profile";
import QuestionTime from "./components/question/QuestionTime";
import Rewards from "./components/reward/Rewards";
import ThankYou from './components/redeem/ThankYou';
import ProtectedRoutes from './components/Auth/Protected';
import WatchSaved from './components/savedVideos/watchSaved';
import WatchSharedVideo from './components/SharedVideo/WatchShareVideo';
import EditProfile from './components/profile/EditProfile';
import Unsub from './components/Unsubscribe/Unsub';
import "./TimeRecorder/TimeRecorder";
import RewardsNew from './components/reward/RewardsNew';
import SpinWheel from './components/reward/SpinWheel';
import Leaderboard from './components/leaderboard/Leaderboard';
import AppBar from './components/header/Appbar';
import ProfileNew from './components/profile/ProfileNew';
import ProfileSettings from './components/profile/ProfileSettings';
import AvatarEditorStylized from './components/profile/AvatarEditor';
import TermsOfService from './components/profile/TermsOfService';
import FAQs from './components/profile/FAQs';
import AvatarChanges from './components/profile/AvatarChanges';
import { CoinProvider } from './components/header/CoinContext';
import WeeklyTriviaSelector from './components/question/WeeklyTriviaSelector';
import WeeklyTrivia from './components/question/WeeklyTrivia';
import RedeemBodyWeekly from './components/redeem/RedeemBodyWeekly';
import ThankYouSubscribe from './components/login/ThankYouSubscribe';
import { useEffect } from 'react';
import './i18n';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './components/profile/LanguageSelector';
// import BottomAppBar from './components/footer/BottomAppBar';

const NullPath = () => {
  useEffect(() => {
    // window.location.href = process.env.REACT_APP_LOGIN_URL;
  }, [])
  return <></>
}

function App() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    // lang -> localStorage -> default 'ar'
    const params = new URLSearchParams(window.location.search);
    const langParam = params.get('lang');
    const savedLang = localStorage.getItem('language');

    if (langParam && (langParam === 'en' || langParam === 'ar')) {
      i18n.changeLanguage(langParam);
      localStorage.setItem('language', langParam);
      localStorage.setItem('language', langParam);
    } else if (savedLang) {
      i18n.changeLanguage(savedLang);
    } else {
      i18n.changeLanguage('ar');
      localStorage.setItem('language', 'ar');
      localStorage.setItem('language', 'ar');
    }
  }, [i18n]);

  useEffect(() => {
    document.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
  }, [i18n.language]);

  return (
    <div>
      {/* <GoogleAnalytics
        trackingId="G-5N4XGKLXTT"  // DING JAZZ ID for the login page
      /> */}
      <Routes>
        {/* <Route path="/login" element={<><Login /></>}> </Route> */}
        {/* <Route path="/login/thankyou" element={<><ThankYouSubscribe /></>}> </Route> */}
        <Route element={<ProtectedRoutes />}>
          <Route path='/terms-service' element={<CoinProvider> <AppBar title={t('terms_of_service')} /> <TermsOfService />  </CoinProvider>} ></Route>
          <Route path='/faqs' element={<CoinProvider> <AppBar title={t('faqs')} /> <FAQs />  </CoinProvider>} ></Route>
          <Route path='/avatar-changes' element={<CoinProvider> <AppBar title={t('profile')} /> <AvatarChanges />  </CoinProvider>} ></Route>

          <Route path="/" element={<> <Home showSplash={true} /><Footer /> </>}> </Route>
          <Route path="/home" element={<> <Home showSplash={true} /><Footer /> </>}> </Route>
          <Route path="/home/landing" element={<> <Home showSplash={false} /><Footer /> </>}> </Route>
          <Route path="/redeem" element={<CoinProvider> <AppBar title={t('redeem')} /><RedeemBody /> </CoinProvider>}> </Route>
          <Route path="/redeem-weekly" element={<CoinProvider> <AppBar title={t('redeem')} /><RedeemBodyWeekly /> </CoinProvider>}> </Route>
          <Route path="/profile" element={<CoinProvider> <AppBar title={t('profile')} /> <ProfileNew /><Footer /> </CoinProvider>}> </Route>
          <Route path="/edit-profile" element={<CoinProvider> <AppBar title={t('edit_profile')} />  <EditProfile /><Footer /> </CoinProvider>}> </Route>
          <Route path="/categories" element={<CoinProvider> <AppBar title={t('categories')} /> <Categories /> <br /> <br /> <br /> <Footer /></CoinProvider>}> </Route>
          <Route path="/shared/video" element={<> <WatchSharedVideo /><Footer /></>}> </Route>
          <Route path="/saved/watch" element={<> <WatchSaved /><Footer /></>}> </Route>
          <Route path="/trivia" element={<CoinProvider> <AppBar title={t('trivia')} /> <QuestionTime /><Footer /> </CoinProvider>}> </Route>
          <Route path="/rewards" element={<> <Rewards /><Footer /></>}> </Route>
          <Route path="/thankyou" element={<><ThankYou /></>}> </Route>
          <Route path="/unsubscribe" element={<><Unsub /></>}> </Route>
          <Route path="/rewards-new" element={<CoinProvider><AppBar title={t('rewards')} /> <RewardsNew /><Footer /></CoinProvider>}> </Route>
          <Route path='/spin-wheel' element={<CoinProvider> <AppBar title={t('spin_wheel')} /> <SpinWheel /></CoinProvider>}></Route>
          <Route path='/leaderboard' element={<CoinProvider> <AppBar title={t('leaderboard')} /> <Leaderboard /> <Footer /> </CoinProvider>}></Route>
          <Route path='/profile-settings' element={<CoinProvider><AppBar title={t('settings')} /> <ProfileSettings /> </CoinProvider>} ></Route>
          <Route path='/analytics' element={<CoinProvider> <AppBar title={t('analytics')} /> <Profile /> </CoinProvider>} ></Route>
          <Route path='/avatar-editor' element={<CoinProvider> <AppBar title={t('edit_avatar')} /> <AvatarEditorStylized /> </CoinProvider>} ></Route>
          <Route path="/saved" element={<CoinProvider> <AppBar title={t('saved_videos')} /> <SavedVideos />  <Footer /></CoinProvider>}> </Route>
          <Route path='/weekly-selection' element={<CoinProvider> <AppBar title={t('topic_selection')} /> <WeeklyTriviaSelector /> </CoinProvider>}></Route>
          <Route path='/weekly-trivia' element={<CoinProvider> <AppBar title={t('weekly_trivia')} /> <WeeklyTrivia /> </CoinProvider>}></Route>
          {/* <Route path='*' element={<Navigate to="/login" />} />\ */}
          <Route path='/language-selector' element={<CoinProvider> <AppBar title={t('select_language')} /> <LanguageSelector /> </CoinProvider>} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;